import React from 'react';
import { ensureUrlEndingWithSlash, isNotEmpty } from '../../../lib/ep';
import { useCommon } from '../../context/commonContext';
import { usePromotion } from '../../context/promotionContext';

import FloatingLayerPublic from '../FloatingLayerPublic';
import LeveledHTMLText from '../helpers/LeveledHTMLText';
import ActionLink from '../../builder/ActionLink';

const PrivacyPolicyLayer = (props) => {
	const { promotion } = usePromotion();
	const promotion_xapuss = props?.promotion ?? promotion;	// once all the frontend is pure react, this can be deleted

	const { domain } = useCommon();
	const domain_xapuss = window?.domain_url ?? domain;	// once all the frontend is pure react, this can be deleted

	if(!isNotEmpty(promotion_xapuss, 'policy')) return null;

	return (
		<FloatingLayerPublic
			pm={promotion_xapuss}
			backButton={props.close}
			is_builder={props?.is_builder ?? false}
		>
			<LeveledHTMLText
				_class={{ other:'gui_justified_text' }}
			>{promotion_xapuss.policy}</LeveledHTMLText>

			<ul class="related_link">
				<li class="link hb_secondaryFont">
					<ActionLink
						_class={{ other:'policy_link' }}
						autotranslate={false}
					>{`https://${ensureUrlEndingWithSlash(domain_xapuss)}policy/${promotion_xapuss.id}`}</ActionLink>
				</li>
			</ul>
		</FloatingLayerPublic>
	)
};

export default PrivacyPolicyLayer;